// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"a093ee09","513":"12b00535","703":"6ebd0512","787":"e5d45f52"}[chunkId] + ".chunk.js";
};